export const memberProfile = {
  "verified": "Επαληθευμένος",
  "online": "Συνδεδεμένος",
  "memberSince": "Μέλος από",
  "contact": "Επικοινωνία",
  "share": "Κοινοποίηση",
  "respondsIn": "Απαντά σε",
  "responseRate": "ποσοστό απάντησης",
  "exchangesCompleted": "Πραγματοποιημένες ανταλλαγές",
  "reviews": "κριτικές",
  "responseRateLabel": "Ποσοστό απάντησης",
  "memberSinceLabel": "Μέλος από",
  "years": "χρόνια",
  "year": "χρόνος",
  "exchangeHistory": "Ιστορικό ανταλλαγών",
  "property": "Κατάλυμα",
  "reviewsTab": "Κριτικές",
  "all": "Όλες",
  "completed": "Ολοκληρωμένες",
  "upcoming": "Επερχόμενες",
  "cancelled": "Ακυρωμένες",
  "exchangeWith": "Ανταλλαγή με",
  "nights": "νύχτες",
  "noExchangeInCategory": "Καμία ανταλλαγή σε αυτή την κατηγορία",
  "offeredProperty": "Προτεινόμενο κατάλυμα",
  "memberReviews": "Κριτικές μελών"
};
